import React, { useState } from 'react';
import AdBanner from '@/components/AdBanner';
import { DiaryActionCards } from '@/components/DiaryActionCards';
import { Layout } from '@/layouts/Layout';
import { DesktopDiary } from '@/pages/Diary/DesktopDiary';
import { MobileDiary } from '@/pages/Diary/MobileDiary';
import { useDiary } from '@/pages/Diary/hooks/useDiary';
import { useDiaryDateRange } from '@/pages/Diary/hooks/useDiaryDateRange';
import { usePreschoolEducationPlans } from '@/pages/Diary/hooks/usePreschoolEducationPlans';
import { useIsMobile } from '@/hooks/useIsMobile';
import { getDatesInRange, getWeekRangeWithin } from '@/utils/date';

export const Diary: React.FC = () => {
  const { from, to, defaultSelectedDate, isCurrentStudyYear } =
    useDiaryDateRange();
  const [pickedDate, setPickedDate] = useState<Date>();
  const isMobile = useIsMobile();

  const isPickedDateBrowsable =
    !!pickedDate && pickedDate >= from && pickedDate <= to;
  const selectedDate = isPickedDateBrowsable ? pickedDate : defaultSelectedDate;
  const browsableDates = getDatesInRange(from, to);
  const browsableWeek = getWeekRangeWithin({ date: selectedDate, from, to });
  const { weekEntries, carouselEntries, areEntriesLoading } = useDiary({
    week: browsableWeek,
    from,
    to,
    shouldLoadAdjacentWeeks: isMobile,
  });
  const preschoolPlans = usePreschoolEducationPlans();

  return (
    <Layout hideMobileHeader desktopHeader={<DiaryActionCards />}>
      <MobileDiary
        entries={carouselEntries}
        preschoolPlans={preschoolPlans}
        areEntriesLoading={areEntriesLoading}
        browsableDates={browsableDates}
        isCurrentStudyYear={isCurrentStudyYear}
        selectedDate={selectedDate}
        minDate={from}
        maxDate={to}
        adBanner={isMobile && <AdBanner className="w-full!" />}
        onDateChange={setPickedDate}
      />

      <DesktopDiary
        entries={weekEntries}
        preschoolPlans={preschoolPlans}
        areEntriesLoading={areEntriesLoading}
        selectedDate={selectedDate}
        minDate={from}
        maxDate={to}
        onDateChange={setPickedDate}
      />

      {!isMobile && <AdBanner className="md:pt-0! md:pb-6" />}
    </Layout>
  );
};
